import React from "react";
import styles from "./Slide3.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../Introduction.messages";

export const Slide3: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.slide3}>
      <h2 className={styles.title}>{formatMessage(messages.slide3Title)}</h2>
      <div className={styles.content}>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide3Title1)}</h3>
          <p>{formatMessage(messages.slide3Description1)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide3Title2)}</h3>
          <p>{formatMessage(messages.slide3Description2)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide3Title3)}</h3>
          <p>{formatMessage(messages.slide3Description3)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide3Title4)}</h3>
          <p>{formatMessage(messages.slide3Description4)}</p>
        </div>
      </div>
    </div>
  );
};
